import type { Column, Row } from '@innovamat/glimmer-components';
import type { Block } from '../../../components/student-drawer/utils/types';
import type { BlockAverage, BlocksAverageReport } from './types';

type GetOrderedBlockAveragesProps = {
  columns: Column<Row>[];
  blockAverages: Record<string, BlockAverage>;
};

export const getOrderedBlockAverages = ({
  columns,
  blockAverages,
}: GetOrderedBlockAveragesProps): BlocksAverageReport => {
  if (!blockAverages || !columns) return [];

  const startIdx = columns.findIndex((col) => col.id === 'separator-4') + 1;
  const orderedColumns = columns.slice(startIdx);

  return orderedColumns
    .filter(
      (col) =>
        Object.prototype.hasOwnProperty.call(blockAverages, col.id) &&
        col.id !== 'otherContents'
    )
    .map((col) => ({ ...blockAverages[col.id], id: col.id }));
};

type GetOrderedStudentBlocksProps = {
  columns: Column<Row>[];
  studentBlocks?: Block[];
};

export const getOrderedStudentBlocks = ({
  columns,
  studentBlocks,
}: GetOrderedStudentBlocksProps): Block[] => {
  if (!studentBlocks || !columns) return [];

  const startIdx = columns.findIndex((col) => col.id === 'separator-4') + 1;
  const orderedColumns = columns.slice(startIdx);

  return orderedColumns
    .map((col) => {
      const studentBlock = studentBlocks.find(
        (block) => block.blockId === col.id
      );

      if (!studentBlock || !studentBlock.blockId) return null;

      return studentBlock;
    })
    .filter((block): block is Block => block !== null);
};
